import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Button } from '../../../../../common/html/button'
import { Element } from '../../../../../common/html/element'
import { Image } from '../../../../../common/image'
import { valToPercent } from '../../../../../helpers/value'
import { COMPONENTS } from '../../../../../routers/constants'
import classes from '../../../../index.module.scss'
import { getMaxDiscountVal } from '../../../helpers'
import { selectPackageListOrigData } from '../../../store/slice'
import BenefitCheckSvg from '../../icon/benefitCheck.svg'
import { PACKAGE_HEIGHT } from '../constants'

export const Package = ({
  isActive,
  handleBuyPackage,
  planId,
  isCustom,
  isBasic,
  fontSizeType,
}) => {
  const packageListData = useSelector(selectPackageListOrigData)
  const locale = useSelector((state) => state.i18n.locale)

  const getBenefitVal = getMaxDiscountVal(
    planId,
    packageListData,
    'discountPercentageByQuantity',
  )

  return (
    <div className={classes.package}>
      {!isCustom ? (
        <>
          <div
            className="flexRow alignItemsCenter justifyContentBetween"
            style={{ height: 23 }}
          >
            <div className="fw600">
              <Translate value="userManagement.upgradeViewPlan.PACKAGE" />
            </div>
            {isActive && isBasic ? (
              <Button
                label="userManagement.buyPackage.BUY_PACKAGE"
                style={{
                  border: 'none',
                  backgroundColor: '#0553A5',
                  color: '#FFFFFF',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  fontSize: 8,
                }}
                className="cursorPointer"
                action={handleBuyPackage}
                isI18n
              />
            ) : (
              <></>
            )}
          </div>
          <div
            className={['flexRow alignItemsCenter', classes.packageRow].join(
              ' ',
            )}
          >
            <Image src={BenefitCheckSvg} className={classes.benefitCheckImg} />
            <div className={classes.packageItem}>
              {`${I18n.t(
                'userManagement.upgradeViewPlan.TRADE_DISCOUNT_UPTO',
              )} ${valToPercent(getBenefitVal, locale, false, false, 0)}`}
            </div>
          </div>
          <div
            className="dFlex justifyContentEnd cursorPointer"
            style={{ color: '#2C73E8' }}
          >
            <Element
              elementName="a"
              style={{ color: '#2C73E8' }}
              href={
                COMPONENTS.userManagement.components.subscriptionPayment
                  .components.packageList.route
              }
              target="_blank"
              className="cursorPointer"
            >
              <Translate value="userManagement.buyPackage.PACKAGE_LIST" />
            </Element>
          </div>
        </>
      ) : (
        <div style={{ height: PACKAGE_HEIGHT[fontSizeType][locale] }}></div>
      )}
    </div>
  )
}
